'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');
var magicSdk = require('@gig/magic-sdk');
var magicAccountTypes = require('@gig/magic-account-types');

function email(fieldConfig) {
    return {
        id: 'email',
        component: 'magic-ui-form-field',
        isDataField: true,
        testId: 'step1-email',
        properties: {
            'type': 'email',
            'placeholder': magicCommon.translate('sign-up-step-one.email.placeholder'),
            'suggestion-message': magicCommon.translate('sign-up-step-one.email.suggestion-message'),
        },
        dynamicProperties: {
            'has-suggestion': hasEmailSuggestion(fieldConfig),
            'suggestion': suggestedEmail(fieldConfig),
        },
        emitHandlers: {
            'apply-suggestion': function ($event) {
                var suggestion = $event.detail[0];
                return { id: 'email', value: suggestion };
            },
        },
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-one.email.error'),
            },
            {
                name: 'email',
                fn: magicFormBuilder.isEmail,
                message: magicCommon.translate('sign-up-step-one.email.error'),
            },
            {
                name: 'availableEmail',
                fn: magicCommon.debounceValidator(function (currEmail) {
                    return magicSdk.magic.methods.users.isEmailAvailable(currEmail);
                }, 200, [magicFormBuilder.required, magicFormBuilder.isEmail]),
                isAsync: true,
                message: magicCommon.translate('sign-up-step-one.email.not-available.error'),
            },
        ],
    };
}
function suggestedEmail(fieldConfig) {
    return function (data) {
        if (!fieldConfig.mailCheck || !data.email.isValid) {
            return '';
        }
        var email = magicAccountTypes.mailCheck(data.email.value, fieldConfig.mailCheckConfig);
        return email !== false ? email.full : '';
    };
}
function hasEmailSuggestion(fieldConfig) {
    var suggestionForConfig = suggestedEmail(fieldConfig);
    return function (data) {
        var suggestedEmail = suggestionForConfig(data);
        return suggestedEmail !== '' && suggestedEmail !== data.email.value;
    };
}

exports.email = email;
exports.hasEmailSuggestion = hasEmailSuggestion;
exports.suggestedEmail = suggestedEmail;
